import React, { useState } from "react";

import Container from "@material-ui/core/Container";
import ApplicationPanel from "../../application/ApplicationPanel";
import ApplicationHeader from "../../application/ApplicationHeader";
import { notBlank } from "../../util/ext";
// import { useLocation } from "react-router-dom";
import MetadataFileDiscoveryBrowse from "./MetadataFileDiscoveryBrowse";
import { useDiscoverySearch } from "./processingDiscoveryServices";
import { Route, useHistory, useRouteMatch } from "react-router-dom";
import withAuthorization from "../../auth/withAuthorization";
import MetadataFileDiscoveryDetailView from "./MetadataFileDiscoveryDetailView";
import ParsedMetadataDetailView from "./ParsedMetadataDetailView";

const generateStartDate = () => {
  const adjustment = 30;

  const currDate = new Date();
  currDate.setDate(currDate.getDate() - adjustment);
  currDate.setUTCHours(0, 0, 0, 0);
  return currDate;
};

const AuthorizedRoute = withAuthorization(Route);

const MetadataFileDiscoveryView = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  // const { state = {} } = useLocation();
  const initialSearchState = {
    orderBy: null,
    orderDirection: "asc",
    startDate: generateStartDate(),
    endDate: new Date(),
    contentProviderId: null,
    contentProviderEndpointId: null,
    appliedFilter: null,
    page: 0,
  };

  const [searchState, setSearchState] = useState(initialSearchState);
  const searchResults = useDiscoverySearch({
    startDate: searchState.startDate,
    endDate: searchState.endDate,
    contentProviderId: searchState.contentProviderId,
    contentProviderEndpointId: searchState.contentProviderEndpointId,
    filter: searchState.appliedFilter,
    order: notBlank(searchState.orderBy)
      ? `${searchState.orderBy},${searchState.orderDirection}`
      : null,
    page: searchState.page,
  });

  return (
    <Container id="metadata-file-discovery" disableGutters>
      <ApplicationHeader />

      <AuthorizedRoute
        exact
        path={`${path}/:jobId/:mediaId`}
        roles={["ROLE_ADMIN"]}
      >
        <ApplicationPanel id="application-panel-content-metadata-parse-detail">
          <ParsedMetadataDetailView onCancel={() => history.push(`${path}`)} />
        </ApplicationPanel>
      </AuthorizedRoute>

      <AuthorizedRoute exact path={`${path}/:jobId`} roles={["ROLE_ADMIN"]}>
        <ApplicationPanel id="application-panel-metadata-disovery-detail">
          <MetadataFileDiscoveryDetailView
            onCancel={() => history.push(`${path}`)}
          />
        </ApplicationPanel>
      </AuthorizedRoute>

      <Route exact path={path}>
        <ApplicationPanel id="application-panel-metadata-discovery">
          <MetadataFileDiscoveryBrowse
            searchState={searchState}
            onSearchStateChange={state => setSearchState(state)}
            searchResults={searchResults}
          />
        </ApplicationPanel>
      </Route>
    </Container>
  );
};

export default MetadataFileDiscoveryView;
